let visitorRoutes = [
    {
        path: '/dashboard/visitor',
        name: 'VisitorDashboard',
        layout: "dashboard-without-sidebar",
        component: () => import(/* webpackChunkName: 'visitor' */ '../pages/VisitorDashboard.vue'),
        meta: {
            requiresAuth: true,
            title: "Visitor Dashboard | Appointment Portal RDCD",
            displayTitle: 'page-titles.visitor-dashboard',
            requiresAuth: true,
            requiresRoles: [ 'USER' ]
        }
    }
];

export { visitorRoutes };